function slugify(text) {
	return text.toString().toLowerCase().trim()
		.replace(/\s+/g, '-')
		.replace(/[^\w-]+/g, '')
		.replace(/--+/g, '-')
}

function convertRemToPixels(rem) {    
	return rem * parseFloat(getFontSize());
}

function scrollToElement(element, options) {
	setTimeout(() => {
		const headerOffset = options?.headerOffset || 0
		const elementPosition = element.getBoundingClientRect().top
		let offsetPosition = elementPosition + window.scrollY - headerOffset

		if(headerOffset < convertRemToPixels(70)) {
			offsetPosition = elementPosition + window.scrollY - convertRemToPixels(70)
		}

		window.scrollTo({
			top: offsetPosition,
			behavior: 'smooth'
		})
	}, 1000)
}

function setCookie(name, value, days) {
	const date = new Date();
	date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
	const expires = `expires=${date.toUTCString()}`;
	document.cookie = `${name}=${value};${expires};path=/`;
}

function getCookie(name) {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
	return null;
}

window.convertRemToPixels = convertRemToPixels

module.exports = {
	slugify: slugify,
	convertRemToPixels: convertRemToPixels,
	scrollToElement: scrollToElement,
	setCookie: setCookie,
	getCookie: getCookie
}